// product page complementary and upsell product slider css using splide js 
class ProductBlockSlider extends HTMLElement {
  constructor(){
    super();
    this.init();
  }

  init() {
    const slider = this.querySelector('.slider');
    if (!slider) return;

    // Destroy existing instance if it exists
    if (slider.splide) {
      slider.splide.destroy();
    }

    // Wait until Splide is defined before initializing
    const waitForSplide = setInterval(() => {
      if (typeof Splide !== 'undefined') {
        clearInterval(waitForSplide);

        const splide = new Splide(slider, {
          type       : 'loop',
          perPage    : 1,
          perMove    : 1,
          autoplay   : false,
          interval   : 3000,
          pagination : false,
          arrows     : true,
          gap        : '1rem',
            breakpoints: {
            999: {
              arrows: false
            }
          }
                  
        });

        // Correctly target the progress bar inside the Splide root
        const bar = slider.querySelector('.my-carousel-progress-bar');

        splide.on('mounted move', () => {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = Math.min((splide.index + 1) / end, 1);
          bar.style.width = `${100 * rate}%`;
        });

        splide.mount();

        // Save reference to destroy it later if needed
        slider.splide = splide;
      }
    }, 100);
  }
}

customElements.define('block-product', ProductBlockSlider);